module.exports = "/dist/images/el.5445a3ea.png";